import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const LineSticker = () => {
  const { ref } = useParams();

  useEffect(() => {
    async function fetchData() {
      if (ref === "2025") {
        window.location.href = "https://line.me/S/sticker/31133308";
      } else {
        window.location.href = "#";
      }
    }
    fetchData();
  }, [ref]); // ✅ ใส่ ref ใน dependency

  return null; // ใช้ null แทน <></> ก็ได้
};

export default LineSticker;
